export const getFolderSpaceRepresentation = (folderSpaceInBytes) => {
    if(folderSpaceInBytes < 1024){
        return `${folderSpaceInBytes} B` 
    }else if (folderSpaceInBytes < (1024 * 1024)){
        return `${(folderSpaceInBytes / 1024).toFixed(1)} KB` 
    }else if (folderSpaceInBytes < (1024 * 1024 * 1024)){
        return `${(folderSpaceInBytes / (1024 * 1024)).toFixed(1)} MB` 
    }else {
        return `${(folderSpaceInBytes / (1024 * 1024 * 1024)).toFixed(1)} GB` 
    }
}